import { faEllipsisH } from "@fortawesome/free-solid-svg-icons";
import SideBarViewStyles from "../../Styles/ChannelViewer/SideBarView.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext, useEffect } from "react";
import Scrollbar from "react-scrollbars-custom";

import { ContextForClient } from "../../Context_file/ClientContext";
import { fetchRequest } from "../../helper/CustomFetch";
import CustomPostList from "./CustomPostList";
import PostForm from "./PostForm";

const FetchPosts = () => {
  const [{ posts, nameDisplayHeader, resizeFlag }, dispatch] =
    useContext(ContextForClient);
  const { ClientPost } = posts && posts;
  const { nav, channel, wrapper } = SideBarViewStyles;

  useEffect(() => {
    const fetchPosts = async () => {
      const url = "randompost",
        storage = "randompost";
      return fetchRequest({ storage, url, dispatch });
    };
    fetchPosts();

    return [fetchPosts];
  }, [dispatch]);

  const noLongerAmember = {
    firstName: "anonymous",
    lastName: "anonymous",
    profileImage: "",
  };

  const renderPosts =
    posts && ClientPost ? (
      ClientPost.map(({ text, createdAt, posterDetails }, index) => {
        let names = posterDetails
          ? `${posterDetails.firstName} ${posterDetails.lastName}`
          : `${noLongerAmember.firstName} ${noLongerAmember.lastName}`;
        let image = posterDetails
          ? posterDetails.profileImage
          : noLongerAmember.profileImage;
        return (
          <CustomPostList
            key={index}
            posts={text}
            createdAt={createdAt}
            image={image}
            names={names}
          />
        );
      })
    ) : (
      <div className="container d-flex justify-content-center align-items-center text-capitalize">
        <h2 style={{ color: "#fff" }}>No data yet</h2>
      </div>
    );

  return (
    <div
      className="container-fluid w-100"
      style={{
        height: "100vh",
        backgroundColor: "#333",
        width: "100%",
      }}
    >
      {!resizeFlag && (
        <div className={`container-fluid position-fixed-top-3 mt-3 ${wrapper}`}>
          <nav className={`${nav}`}>
            <span>
              {
                <FontAwesomeIcon
                  icon={faEllipsisH}
                  color="#fff"
                  size="lg"
                  cursor="pointer"
                  onClick={() =>
                    `${dispatch({
                      type: "RESIZE_SCREEN",
                      payload: !resizeFlag,
                    })}, ${dispatch({
                      type: "SHOW_TIMES_ICON",
                      payload: true,
                    })}`
                  }
                />
              }
            </span>
          </nav>
          <div className={channel}>
            <span>{nameDisplayHeader}</span>
          </div>
        </div>
      )}
      <div
        className="w-100"
        style={{ height: "75vh", backgroundColor: "#333" }}
      >
        <Scrollbar>{renderPosts}</Scrollbar>
        <PostForm />
      </div>
    </div>
  );
};

export default FetchPosts;
